<template>
    <div class="d-flex vh-100">
        <AuthSidebar />

        <!-- Main Content -->
        <div class="content flex-grow-1 d-flex flex-column">
            <!-- Navbar -->
            <AuthNavbar />

            <!-- Main View -->
            <main class="p-4 flex-grow-1">
                <router-view />
            </main>

            <!-- Footer -->
            <AuthFooter />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AuthSidebar from "./auth/AuthSidebar.vue";
import AuthNavbar from "./auth/AuthNavbar.vue"
import AuthFooter from "./auth/AuthFooter.vue";

export default defineComponent({
    components: {
        AuthSidebar,
        AuthNavbar,
        AuthFooter
    },
});
</script>

<style scoped>
.content {
    display: flex;
    flex-direction: column;
}

.nav-link {
    padding: 10px;
    font-size: 1rem;
}

.nav-link:hover {
    background: rgba(255, 255, 255, 0.1);
}
</style>